import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
const Registro = ({ Isadmin, tabla, close, update, datosUser }) => {
  const history = useNavigate();

  const inicial = {
    nombre: "",
    apellido: "",
    cedula: "",
    mesa: "",
    lugarVotacion: "",
    barrioResidencia: "",
    Telefono: "",
    TelefonoResponsable: "",
    perfilProfesional: "",
    Actual: "",
    lider: 1,
    compromiso: "",
    comunidad: "",
  };
  const compare = (a, b) => {
    return a === b;
  };
  const [datos, setDatos] = useState(inicial);
  const [dataLider, setDataLider] = useState([]);

  useEffect(() => {
    const tablaF = async () => {
      const res = await fetch(`${process.env.REACT_APP_SERVER_URL}/lider.php`);
      const data = await res.json();
      setDataLider(data);
      // Actualizar el lider por defecto con el primero real de la BD
      if (!update && data.length > 0) {
        setDatos((prev) => ({ ...prev, lider: data[0].id_lider }));
      }
    };
    tablaF();
    document.title = ` Registro | ${process.env.REACT_APP_TITLE}`;
    if (update) setDatos(datosUser);
    // eslint-disable-next-line
  }, []);

  const [vali, setVali] = useState(false);
  var forms = document.querySelectorAll(".needs-validation");
  const cambio = (e) => {
    Array.prototype.slice.call(forms).forEach(function (form) {
      if (!form.checkValidity()) {
        e.preventDefault();
        e.stopPropagation();
        form.classList.add("was-validated");
        setVali(false);
      } else {
        setVali(true);
      }
    });
    const { name, value } = e.target;
    setDatos({ ...datos, [name]: value });
  };
  const env = async (e) => {
    e.preventDefault();

    if (vali) {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/registro.php`,
        {
          method: update ? "PUT" : "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(datos),
        }
      );
      const data = await res.json();

      if (data.cc) {
        Array.prototype.slice.call(forms).forEach(function (form) {
          e.stopPropagation();
          form.classList.remove("was-validated");

          form.elements.cedula.classList.add("is-invalid");
          let texto = document.querySelector(".cedula");
          texto.innerText = `${data.cc}`;
        });
      }

      if (data.id_) {
        setDatos({ ...datos, id: data.id_ });
        Isadmin ? close() : <></>;
        Isadmin
          ? tabla()
          : localStorage.setItem(
              "User",
              JSON.stringify({ ...datos, id: data.id_ })
            );
        Isadmin ? <></> : history("/");
      } else if (data > 0) {
        Swal.fire("Update!", "Your User has been Update.", "success");
      } else {
        var html = document.documentElement;
        html.scrollTop = 10;
        let alerta = document.querySelector(".alert-danger");
        alerta.classList.remove("d-none");
        alerta.innerHTML = data.error_insert || (data.result && data.result.error_msg) || "Error interno. Revise su información y vuelva a intentarlo.";
      }
    } else {
      Array.prototype.slice.call(forms).forEach(function (form) {
        if (!form.checkValidity()) {
          e.preventDefault();
          e.stopPropagation();
          form.classList.add("was-validated");
        }
      });
    }
  };

  return (
    <>
      <div className="container">
        <div className=" d-flex justify-content-center alert alert-danger d-none mt-4">
          -
        </div>
        <div className="row g-5 justify-content-center">
          <div className="py-5 text-center">
            <h2> {update ? "Actualizar" : "Crear Registro"} </h2>
          </div>

          <div className="col-xs-12 col-md-12 col-lg-8 ">
            <form
              onSubmit={env}
              className="needs-validation"
              noValidate
              method="post"
            >
              <div className="row g-3">
                <div className="col-sm-4">
                  <label htmlFor="firstName" className="form-label">
                    Nombre
                  </label>
                  <input
                    type="text"
                    value={datos.nombre}
                    onChange={cambio}
                    className="form-control"
                    id="firstName"
                    name="nombre"
                    required
                  />
                  <div className="invalid-feedback">Nombre es requerido.</div>
                </div>
                <div className="col-sm-4">
                  <label htmlFor="lastName" className="form-label">
                    Apellido
                  </label>
                  <input
                    type="text"
                    value={datos.apellido}
                    onChange={cambio}
                    className="form-control"
                    id="lastName"
                    name="apellido"
                    required
                  />
                  <div className="invalid-feedback">
                    Apellido es requerido .
                  </div>
                </div>
                <div className="col-sm-4">
                  <label htmlFor="cedula" className="form-label">
                    Cedula
                  </label>
                  <input
                    type="number"
                    value={datos.cedula}
                    onChange={cambio}
                    className="form-control"
                    id="cedula"
                    name="cedula"
                    required
                  />
                  <div className="invalid-feedback cedula">
                    Cedula es requerida
                  </div>
                </div>
                <div className="col-sm-4">
                  <label htmlFor="" className="form-label">
                    Nuemro de mesa
                  </label>
                  <input
                    type="number"
                    value={datos.mesa}
                    onChange={cambio}
                    className="form-control"
                    id="mesa"
                    name="mesa"
                    required
                  />
                  <div className="invalid-feedback">Mesa es requerido.</div>
                </div>
                <div className="col-sm-4">
                  <label htmlFor="" className="form-label">
                    Lugar de votacion
                  </label>
                  <select
                    onChange={cambio}
                    className="form-select"
                    name="lugarVotacion"
                    id="lugarVotacion"
                    required
                  >
                    <option selected value={datos.lugarVotacion}>
                      {datos.lugarVotacion}
                    </option>
                    <option value="lloro">Lloro</option>
                    <option value="quibdo">Quibdo</option>
                    <option value="La vuelta">La vuelta</option>
                    <option value="Boraudo">Boraudo</option>
                    <option value="Villa Claret">Villa Claret</option>
                    <option value="Las hamacas">Las hamacas</option>
                    <option value="Villa Nueva">Villa Nueva</option>
                    <option value="La playa">La playa</option>
                    <option value="Guaitado">Guaitado</option>
                    <option value="Nipurdu">Nipurdu</option>
                    <option value="Tumutumbudo">Tumutumbudo</option>
                  </select>
                </div>
                <div className="col-sm-6">
                  <label htmlFor="" className="form-label">
                    Lugar de residencia
                  </label>

                  <select
                    onChange={cambio}
                    className="form-select"
                    name="barrioResidencia"
                    id="barrioResidencia"
                    required
                  >
                    <option selected value={datos.barrioResidencia}>
                      {datos.barrioResidencia}
                    </option>
                    <option value="quibdo">Quibdó</option>

                    <option value="Antiguo lloro">Antiguo lloro</option>
                    <option value="Nuevo lloro">Nuevo lloro</option>
                    <option value="GIGUADO">GIGUADO</option>
                    <option value="TONOA">TONOA</option>
                    <option value="CHORRITO ALTO">CHORRITO ALTO</option>
                    <option value="CHORRITO BAJO">CHORRITO BAJO</option>
                    <option value="SAN VICENTE">SAN VICENTE</option>
                    <option value="TODUO">TODUO</option>
                    <option value="medellin">Medellin</option>
                    <option value="TUMUTUMBUDO/LLANO">TUMUTUMBUDO/LLANO</option>
                    <option value="YARUMAL">YARUMAL</option>
                    <option value="NIPURDU">NIPURDU</option>
                    <option value="GERVACION">GERVACION</option>
                    <option value="P. MORENO">P. MORENO</option>
                    <option value="PLAYA">PLAYA</option>
                    <option value="В. САРА">В. САРА</option>
                    <option value="VILLA CLARET">VILLA CLARET</option>
                    <option value="CANCHIDO">CANCHIDO</option>
                    <option value="SAN JORGE">SAN JORGE</option>
                    <option value="HAMACAS">HAMACAS</option>
                    <option value="OGODO">OGODO</option>
                    <option value="CANALETE">CANALETE</option>
                    <option value="LA VUELTA">LA VUELTA</option>
                    <option value="BORAUDO">BORAUDO</option>
                    <option value="PEÑALOSA">PEÑALOSA</option>
                    <option value="GUACERUMA">GUACERUMA</option>
                    <option value="PLAYA ALTA">PLAYA ALTA</option>
                    <option value="GUAITADO">GUAITADO</option>
                    <option value="CURRUPA">CURRUPA</option>
                    <option value="CHIRRIQUI">CHIRRIQUI</option>
                    <option value="CHAGARAMIA">CHAGARAMIA</option>
                    <option value="PLAYON">PLAYON</option>
                    <option value="MUMBU">MUMBU</option>
                    <option value="AGUACATE">AGUACATE</option>
                    <option value="PARRUGUEDA">PARRUGUEDA</option>
                    <option value="PEÑITA">PEÑITA</option>
                    <option value="MINDO">MINDO</option>
                    <option value="GUADUALITO">GUADUALITO</option>
                    <option value="TEGABERA">TEGABERA</option>
                    <option value="PLATINO">PLATINO</option>
                    <option value="HURTADO">HURTADO</option>
                    <option value="PEÑA INDIA">PEÑA INDIA</option>
                    <option value="AMIA">AMIA</option>
                    <option value="TOCOLLORO">TOCOLLORO</option>
                    <option value="CARECUI">CARECUI</option>
                    <option value="CHORRITO">CHORRITO</option>
                    <option value="LANA">LANA</option>
                    <option value="CUMA">CUMA</option>
                    <option value="TIRAVENAO">TIRAVENAO</option>
                    <option value="MURANDO">MURANDO</option>
                    <option value="KIPARA">KIPARA</option>
                    <option value="ANTOLINO">ANTOLINO</option>
                    <option value="GIGUADO">GIGUADO</option>
                    <option value="CHORRITO">CHORRITO</option>
                  </select>
                  <div className="invalid-feedback">
                    barrio de residencia es requerido.
                  </div>
                </div>
                <div className="col-sm-6">
                  <label htmlFor="" className="form-label">
                    Telefono
                  </label>
                  <input
                    type="number"
                    value={datos.Telefono}
                    onChange={cambio}
                    className="form-control"
                    id="Telefono"
                    name="Telefono"
                    required
                  />
                  <div className="invalid-feedback">Telefono es requerido.</div>
                </div>
                <div className="col-sm-6">
                  <label htmlFor="" className="form-label">
                    Perfil profesional
                  </label>
                  <input
                    type="text"
                    value={datos.perfilProfesional}
                    onChange={cambio}
                    className="form-control"
                    id="perfilProfesional"
                    name="perfilProfesional"
                    required
                  />
                  <div className="invalid-feedback">Perfil es requerido.</div>
                </div>
                <div className="col-sm-6">
                  <label htmlFor="" className="form-label">
                    Compromiso
                  </label>

                  {/* <select
                      onChange={cambio}
                      className="form-select"
                      name="compromiso"
                      id="compromiso"
                      required
                    >
                      <option selected value={datos.compromiso}>
                        {datos.compromiso}
                      </option>
                      <option value="pendiente">pendiente</option>
                      <option value="cumplido">cumplido</option>
                      <option value="Al llegar">Al llegar</option>
                      <option value="Dia de">Dia de</option>
                      <option value="1">Escribir</option>
                    </select> */}
                  <input
                    list="browsers"
                    onChange={cambio}
                    name="compromiso"
                    className="form-control"
                    defaultValue={datos.compromiso}
                  />
                

                  <div className="invalid-feedback">
                    Compromiso es requerido.
                  </div>
                </div>
                <div className="col-sm-4">
                  <label htmlFor="" className="form-label">
                    lider
                  </label>

                  <select
                    onChange={cambio}
                    className="form-select"
                    name="lider"
                    id="lider"
                    required
                  >
                    {dataLider.map((user) => {
                      return (
                        <option
                          key={user.id_lider}
                          selected={compare(user.id_lider, datos.id_lider)}
                          value={user.id_lider}
                        >
                          {user.nombreLider} {user.apellidoLider}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-sm-4">
                  <label htmlFor="" className="form-label">
                    Telefono del responsable
                  </label>
                  <input
                    type="number"
                    value={datos.TelefonoResponsable}
                    onChange={cambio}
                    className="form-control"
                    id="TelefonoResponsable"
                    name="TelefonoResponsable"
                    required
                  />
                  <div className="invalid-feedback">Telefono es requerido.</div>
                </div>{" "}
                <div className="col-sm-6 ">
                  <label htmlFor="" className="form-label">
                    Comunidades
                  </label>
                  <select
                    onChange={cambio}
                    className="form-select"
                    name="comunidad"
                    id="comunidad"
                    required
                  >
                    <option selected value={datos.comunidad}>
                      {datos.comunidad}
                    </option>
                    <option value="Comunidad Afro">Comunidades afro</option>
                    <option value="Comunidad Indigena">
                      Comunidades indigena
                    </option>
                  </select>
                </div>
                <div className="col-sm-6 ">
                  <label htmlFor="" className="form-label">
                    Registro de cedula
                  </label>
                  <select
                    onChange={cambio}
                    className="form-select"
                    name="Actual"
                    id="Actual"
                    required
                  >
                    <option selected value={datos.Actual}>
                      {datos.Actual}
                    </option>
                    <option value="Actual">Actual</option>
                    <option value="Antigua">Antigua</option>
                  </select>
                </div>
              </div>

              <button className="w-100 btn btn-dark btn-lg mt-5" type="submit">
                {update ? "Actualizar" : "Añadir votante"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default Registro;
